<template>
  <div class="pt-16">
    <h2 class="pt-6 pb-3">Import Recurring Charge Files</h2>
    <v-container fluid pa-0 ma-0>
      <v-card>
        <v-row no-gutters style="height: 150px" align="center">
          <v-col cols="6" class="pl-16">
            <v-file-input
              label="Import file"
              v-model="file"
              @change="readCSV"
            ></v-file-input>
          </v-col>
          <v-col>
            <v-btn
              @click="upload"
              :disabled="disbleImportBtn || !file"
              class="primary"
              >Submit</v-btn
            >
            <!-- @click="importToUb" -->
          </v-col>
          <v-col>
            <v-btn class="primary" @click="downloadCsvExample"
              >Example data</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
      <v-overlay :value="processingImport">
        <v-progress-circular indeterminate color="primary" size="64"
          >Importing...</v-progress-circular
        >
      </v-overlay>
      <v-alert type="success" :value="importDone" text
        >{{ alertMessage }}
      </v-alert>
      <v-alert v-if="errorMessage" text type="error">
        {{ errorMessage }}
      </v-alert>
    </v-container>
    <v-container>
      <v-col cols="3" align="left">
        <span class="subtitle-1 pl-4 pt-4 d-inline-block">Import Summary</span>
      </v-col>

      <v-card>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
        >
        </ag-grid-vue>
      </v-card>
    </v-container>
    <v-overlay :value="isLoading"></v-overlay>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card class="py-4">
        <v-card-text class="pb-0">
          Processing file uploaded
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { HTTP } from "@/http-common";
import parse from "csv-parse";
import { recurringChargesHeaders } from "@/data/csvHeaders";
import { recurringCharges } from "@/data/csvExampleData";
export default {
  name: "ImportChargeFile",
  components: {
    AgGridVue,
  },
  data: () => ({
    gridApi: {},
    gridColumnApi: {},
    gridOptions: {},
    defaultColDef: {
      resizable: true,
    },
    columnDefs: null,
    file: null,
    dialog: false,
    rowData: [],
    errorMessage: null,
    fileContents: null,
    importBtnLabel: "Import to UB",
    alertMessage: "",
    disbleImportBtn: true,
    processingImport: false,
    importDone: false,
    isLoading: false,
    hasError: false,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.gridApi.sizeColumnsToFit();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = { defaultToolPanel: "" };
    vm.columnDefs = [
      {
        headerName: "Service ID",
        field: "serviceNo",
        sortable: true,
      },
      {
        headerName: "Customer No",
        field: "custNo",
        sortable: true,
      },
      {
        headerName: "Amount",
        field: "amountRecurring",
        sortable: true,
        cellRenderer: (params) => {
          if (!params.value == undefined) {
            return params.value.toFixed(2);
          }
          return params.value;
        },
      },
      {
        headerName: "Description",
        field: "description",
        sortable: true,
      },
      {
        headerName: "Start Date",
        field: "startDate",
        sortable: true,
      },
      {
        headerName: "End Date",
        field: "endDate",
        sortable: true,
      },
      {
        headerName: "Success",
        field: "success",
        sortable: true,
      },
      {
        headerName: "Reason",
        field: "reason",
        sortable: true,
      },
    ];
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      vm.gridApi.sizeColumnsToFit();
    },

    parseCSV() {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        let vm = this;
        reader.readAsText(this.file);
        reader.onload = (e) => {
          parse(
            reader.result,
            {
              columns: true,
              skip_empty_lines: true,
              skip_lines_with_empty_values: true,
              escape: "$",
            },
            function(err, output) {
              if (err) {
                vm.errorMessage = err;
                reject(err);
              } else {
                vm.rowData = output;
                resolve(output);
              }
            }
          );
        };
      });
    },
    async readCSV() {
      let vm = this;
      vm.importDone = false;
      vm.errorMessage = "";

      if (!vm.file.name.toLowerCase().includes("csv")) {
        vm.isLoading = false;
        vm.file = null;
        vm.disbleImportBtn = true;
        vm.errorMessage = "Please upload CSV File";
        return;
      }
      try {
        await this.parseCSV();
        vm.disbleImportBtn = false;
      } catch (error) {
        this.errorMessage = error;
      }
    },
    async upload() {
      let vm = this;
      this.errorMessage = null;
      let formData = new FormData();
      if (vm.file.name.toLowerCase().includes("csv") && !vm.rowData) {
        vm.fileContents = await this.parseCSV();
      }

      formData.append("file", this.file);
      this.importFile(formData)
        .then((data) => {
          this.rowData.forEach((e, index) => {
            e.reason = data.data[index].reason;
            e.success = data.data[index].success;
          });
          this.gridApi.hideOverlay();
          this.importBtnLabel = "Import to UB";
          this.disbleImportBtn = false;
          this.gridApi.sizeColumnsToFit();
          this.isLoading = false;
        })
        .catch((err) => {
          this.errorMessage = err.response.data.message;
          this.gridApi.hideOverlay();
          this.processingImport = false;
        });
    },
    importFile(formData) {
      let vm = this;
      vm.disbleImportBtn = true;
      this.gridApi.showLoadingOverlay();
      return new Promise((resolve, reject) => {
        let response = HTTP.post(
          "BulkUpload/importRecurringChargeFile",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        response
          .then((data) => {
            let res = data.data.data.map((e, index) => {
              return {
                ...e.return,
                ...vm.rowData[index],
                success: !e.return.isError && !e.return.errorDescription,
                reason:
                  e.return.isError || e.return.errorDescription
                    ? e.return.errorDescription
                    : "OK",
              };
            });
            vm.rowData = res;
            vm.file = null;
            vm.disbleImportBtn = true;
            if (res.some((e) => e.success == false)) {
              vm.errorMessage = "Errors encountered.";
            } else {
              vm.importDone = true;
              vm.alertMessage = "OK";
            }

            resolve(data);
          })
          .catch((err) => {
            this.processingImport = false;
            this.errorMessage = err;
            this.gridApi.hideOverlay();

            reject(err);
          });
      });
    },
    downloadCsvExample() {
      var rows = [];
      var headers = recurringChargesHeaders;
      // rows.push(headers.map((item) => item.field));
      rows.push(headers.slice(0, headers.length - 2).map((item) => item.field));
      rows.push(recurringCharges);

      // rows = rows.concat(this.exampleData);

      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "RecurringChargesExampleData.csv");
      link.click();
    },
    onClose() {
      this.dialog = false;
    },
  },
};
</script>
